import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom';
import { appRouter } from './router';
import { IntlProviderWrapper } from './hocs/IntlProviderWrapper';
import {
  setReduxLocale,
  setStoreId,
  setStoreStatics,
  setSupportedLanguages,
} from './store';
import Loader from './components/loader';
import PageProps from './components/commons/pageProperties';
import ModalContainer from './containers/modal';
import { getStoreConfig } from './constants/literals';
import { gaNewLandingAccess, gaSubSectionAccess } from './services/analitics';
import { removeBrand } from './utils/brandUtils';
import { userLocale } from './utils/userLocale';
import { findLocale } from './utils/findLocale';
import './styles/main.scss';

const StoreDirectory = ({ storeId, basename }) => {
  const [loading, setLoading] = React.useState(true);
  const dispatch = useDispatch();
  const storeConfig = getStoreConfig(storeId);
  const location = useLocation();

  async function getAppConfig() {
    const language = findLocale(userLocale(), storeId);
    dispatch(setStoreId(storeId));
    dispatch(setSupportedLanguages(storeConfig.StoreSuportedLanguages));
    dispatch(setReduxLocale(language));
    dispatch(
      setStoreStatics({
        floorStatics: storeConfig.floorStatics,
        HomeStatics: storeConfig.HomeStatics,
      })
    );
    setLoading(false);
    removeBrand();

    //Analitics first Landing Access
    const path = location.pathname.split('/').filter((a) => a !== '');
    const PreHomevisited = JSON.parse(sessionStorage.getItem('welcome'));
    if (PreHomevisited === null && path.length === 2) {
      gaNewLandingAccess(storeId, language);
    } else if (path.length > 2) {
      //Get Floor Info after render landing in a subsection
      const floorConfigs = Object.keys(storeConfig.floorStatics).map(
        (locationKey) => storeConfig.floorStatics[locationKey]
      );
      const sectonPath = `/${path[2]}`;
      const floorInfo = floorConfigs.find(
        (el) => el.sectionPath === sectonPath
      );
      if (floorInfo) {
        gaSubSectionAccess(
          storeId,
          language,
          floorInfo.floorKey,
          floorInfo.sectionKey,
          window.location.href
        );
      }
    }
  }

  const readyToLoad = React.useCallback(getAppConfig, []);

  React.useEffect(() => {
    readyToLoad();
  }, [readyToLoad]);

  if (!loading) {
    return (
      <>
        <Helmet>
          <meta name="theme-color" content="#fff" />
        </Helmet>
        <Router basename={`store/details/${basename}/`}>
          <CookiesProvider>
            <Switch>
              <Suspense fallback={<Loader full />}>
                <ModalContainer>
                  <IntlProviderWrapper>
                    <PageProps
                      title={'store.title'}
                      description={'store.description'}
                    />
                    {appRouter(storeConfig.floorStatics, basename).map(
                      (route) => (
                        <Route
                          key={route.path}
                          path={route.path}
                          exact={route.exact}
                          component={() =>
                            route.Component(route.path, route.children)
                          }
                        />
                      )
                    )}
                  </IntlProviderWrapper>
                </ModalContainer>
              </Suspense>
            </Switch>
          </CookiesProvider>
        </Router>
      </>
    );
  }
  return null;
};

export default StoreDirectory;
